<template>
  <b-modal
    :visible="value"
    ref="export-data-modal"
    centered
    no-close-on-backdrop
    @close="$emit('close')"
    title="Export Data"
    size="small"
  >
    <div class="form-group">
      <label for="filename">File name</label>
      <input class="form-control" v-model="currentFileName" />
      <div class="text-danger" v-if="filenameError">Must not includes "/"</div>
    </div>
    <span class="fw-500">Data column</span>
    <div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="export-column" value="custom"
          id="custom-export" v-model="exportColumn" />
        <label class="form-check-label" for="custom-export"> Custom </label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="export-column" value="all" id="custom-column"
          v-model="exportColumn" />
        <label class="form-check-label" for="custom-column"> All columns </label>
      </div>
    </div>
    <template v-slot:modal-footer="{ close }">
      <div class="d-flex justify-content-end w-100" style="gap: 8px">
        <button type="button" class="btn btn-light" @click="close">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="onExport" :disabled="filenameError">
          Export
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
export default {
  name: 'ExportDataModal',
  emits: ['close', 'export'],
  components: { BModal },
  props: {
    value: { type: Boolean, required: true },
    filename: { type: String, default: '' }
  },
  data() {
    return {
      currentFileName: '',
      exportColumn: 'custom'
    }
  },
  mounted() {
    this.currentFileName = this.filename.replace(/\//g, '')
  },
  watch: {
    filename: function (newValue, oldValue) {
      this.currentFileName = (newValue || '').replace(/\//g, '')
    }
  },
  methods: {
    onExport() {
      if (!this.filenameError) {
        this.$emit('export', {
          currentFileName: this.currentFileName,
          exportColumn: this.exportColumn
        })
      }
    }
  },
  computed: {
    filenameError() {
      return this.currentFileName.includes('/')
    }
  }
}
</script>
